<template>
  <div id="app">
    <header-component />
    <search-section class="d-none d-lg-block" />
    <div>
      <force-password-reset-modal
        :show="passwordResetNeeded"
      />
      <router-view v-if="!passwordResetNeeded" :key="$route.fullPath" />
      <bottom-nav v-if="isMobile" />
    </div>
    <footer-component :class="isMobile ? 'pb-5' : ''" />
    <ToastContainer ref="toastContainer" />
  </div>
</template>

<script>
import BottomNav from "./components/BottomNav.vue";
import FooterComponent from "./components/FooterComponent.vue";
import ForcePasswordResetModal from "./components/ForcePasswordResetModal.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import SearchSection from './components/SearchSection.vue';
import ToastContainer from "./components/ToastContainer.vue";
import { toastService } from "./services/toast";

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
    BottomNav,
    ToastContainer,
    ForcePasswordResetModal,
    SearchSection,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 992,
    };
  },
  computed: {
    // isLoggedIn() {
    //   // Check if a token exists in local storage
    //   return !!localStorage.getItem("token");
    // },
    passwordResetNeeded() {
      return this.$store.state.passwordResetNeeded;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateSize);

    // Let plain-JS code (the store) reach the existing toast component.
    toastService.register(this.showToast);

    // Boot for a returning logged-in user.
    if (this.$store.state.token) {
      // TODO: remove after 2026-12-13 — one-time migration. Users who logged in
      // before guest+server sync shipped may still have guest items in
      // localStorage; merge them instead of overwriting. Self-cleaning
      // (mergeGuestData clears localStorage), so it fires at most once per user.
      const hasLocal =
        this.$store.state.cart.length ||
        this.$store.state.wishlist.length ||
        localStorage.getItem("bk_pendingMerge");
      this.$store.dispatch(hasLocal ? "mergeGuestData" : "hydrateFromServer");
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateSize);
  },
  methods: {
    updateSize() {
      this.isMobile = window.innerWidth <= 992;
    },
    // logout() {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("username");
    //   this.$router.push("/").then(() => {
    //     window.location.reload(); // Reloads the entire application
    //   });
    // },
    showToast(payload) {
      this.$refs.toastContainer.showToast(payload);
    },
  },
};
</script>

<style scoped>
#app {
  margin-top: 85px;
}

@media (max-width: 991px) {
  #app {
    margin-top: 110px;
  }
}
</style>
